import { PARAM_NAME } from '../config/facets';
import Url from '../helpers/UrlHelper';
import { searchInitialState } from '../reducers/searchReducer';

export const SET_FACET_VALUE = 'SET_FACET_VALUE';
export const SET_PAGE = 'SET_PAGE';
export const SYNC_FACET_VALUE = 'SYNC_FACET_VALUE';
export const RESET_FILTERS = 'RESET_FILTERS';

export const setFacetValue = (facetType, value) => (dispatch) => {
  dispatch({ type: SET_FACET_VALUE, payload: { [facetType]: value } })
}

export const setPage = (page) => (dispatch) => {
  dispatch({ type: SET_PAGE, payload: page });
  window.scrollTo(0, 0)
}

export const resetFilters = () => (dispatch) => {
  Object.values(PARAM_NAME).forEach(param => {
    Url.setParam(param, '');
  })
  Url.setParam('page', '');

  dispatch({ type: RESET_FILTERS })
}

export const syncStateWithUrl = () => (dispatch) => {
  const urlParams = new URLSearchParams(window.location.search);
  const payload = searchInitialState;

  Object.keys(PARAM_NAME).forEach(facet => {
    if (urlParams.has(PARAM_NAME[facet])) {
      payload.facets[facet] = urlParams.get(PARAM_NAME[facet]);
    }
  })

  const page = Url.getParam('page');
  payload.page = page ? page : 0;

  dispatch({ type: SYNC_FACET_VALUE, payload })
}
